import React, { useState } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight } from "react-icons/bs";
import { GalleryImages } from "./GalleryImages";

const GallerySlider = ({ images }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? images.length - 1 : currentSlide - 1);
  };

  const nextSlide = () => {
    setCurrentSlide(currentSlide === images.length - 1 ? 0 : currentSlide + 1);
  };

  return (
    <div className="max-w-[1200px] h-[500px] m-auto mb-4 px-4 relative group">
      <div
        // style={{
        //   backgroundImage:
        //     window.innerWidth <= "768"
        //       ? `url(${GalleryImagesHalf[currentSlide]})`
        //       : `url(${GalleryImages[currentSlide]})`,
        // }}
        className="w-full h-full rounded-lg bg-center bg-cover duration-500"
      >
        <img
          src={GalleryImages[currentSlide]}
          alt=""
          loading="lazy"
          fetchpriority="low"
          className="w-full h-full object-contain"
        />
      </div>
      {/* Left Arrow */}
      <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-[#FF0080] cursor-pointer">
        <BsChevronCompactLeft onClick={prevSlide} size={30} />
      </div>
      {/* Right Arrow */}
      <div className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-[#FF0080] cursor-pointer">
        <BsChevronCompactRight onClick={nextSlide} size={30} />
      </div>
    </div>
  );
};

export default GallerySlider;
